import type { ReactElement } from 'react'

import * as styles from './table.styles'

type Props = {
  children: ReactElement | ReactElement[]
  className?: string
}

export const Table = ({ children, className, ...rest }: Props) => (
  <table className={className} css={styles.root} data-testid="table" {...rest}>
    {children}
  </table>
)
